import React from 'react';
import { toast, type ToastOptions } from 'react-toastify';

import { Toast } from 'components/shared/Toast';

export const showToast = ({
  toastOptions = {},
  data,
  component = Toast,
}: {
  toastOptions?: ToastOptions;
  data: Partial<React.ComponentProps<typeof Toast>>;
  component?: typeof Toast;
}) => {
  const Component = component;

  toast(<Component {...(data as React.ComponentProps<typeof Toast>)} />, {
    ...toastOptions,
    closeOnClick: true,
    autoClose: 2000,
    closeButton: () => null,
  });
};
